import React from 'react';
import { Divider } from '../../components/divider';
export default function MobileDivider(props) {
    var show = props.show, section = props.section;
    var separatorColor = section.separatorColor;
    if (!show) {
        return null;
    }
    return (React.createElement(Divider, { borderWidth: "0px", width: "0px", borderColor: separatorColor, cssClass: "html-emails-footer-divider" }));
}
//# sourceMappingURL=mobile-divider.js.map